import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  className?: string;
}

const PageContentWrap: FC<IProps> = ({ children, className }) => (
  <div className={classNames(css.page__contentWrap, className)}>{children}</div>
);

export default PageContentWrap;
